module.exports = __webpack_public_path__ + "img/pwd_success.f313af35.svg";